import { useQuery, UseQueryOptions } from "react-query";
import TranslationLabelsCacheName from "../../utils/TranslationLabelsCacheName";
import {
  FetchTranslationExportsParams,
  fetchTranslationLabels,
  TranslationMode,
} from "../../api/fetchTranslationLabels";
import { Label } from "../../model/Label";

export const useFetchTranslationLabels = (
  translationLabelParams: FetchTranslationExportsParams,
  mode: TranslationMode
) => {
  return useQuery<Label[], Error>(
    [TranslationLabelsCacheName.getLibelleList(), translationLabelParams],
    () => fetchTranslationLabels(translationLabelParams, mode),
    { refetchOnMount: true, enabled: !!translationLabelParams.translationId }
  );
};
